// @flow
import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import ToggleButtonGroup from "react-bootstrap/lib/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/lib/ToggleButton";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import SettingValue, { type SettingValueProps } from "containers/SettingValue";
import bowser from "data/bowser";
import loc from "i18next";

type Props = {
    /** persisted search radius */
    showSearchOperators: SettingValueProps,
};

export const ToggleMode = ({ showSearchOperators }: Props) => (
    <ToggleButtonGroup
        bsSize="small"
        id="toggleMode"
        type="checkbox"
        name="toggleMode"
        value={[showSearchOperators.value ? "op" : null]}
        onChange={() =>
            showSearchOperators.setValue(!showSearchOperators.value)
        }
    >
        <ToggleButton
            bsStyle={bowser.is("mobile") ? undefined : "link"}
            key="tm-op"
            value="op"
            title={loc.t("search:form.toggleOperators")}
        >
            {bowser.is("mobile") ? (
                <FontAwesome name="filter" style={{ margin: 0, padding: 0 }} />
            ) : (
                loc.t("search:form.toggleOperators")
            )}
        </ToggleButton>
    </ToggleButtonGroup>
);
ToggleMode.displayName = "ToggleMode";
export default compose(
    connect(),
    SettingValue({
        name: "showSearchOperators",
        namespace: "showSearchOperators",
        defaultValue: false,
    })
)(ToggleMode);
